module.exports = __webpack_public_path__ + "img/T4-C-xh_13.2c47ee23.png";